/* eslint-disable */
import React, { useContext } from 'react';
import { Typography, Box, CircularProgress } from '@material-ui/core';
import moment from 'moment-timezone';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { DEPARTMENT_AA, DEPARTMENT_BDM } from '../constants/departmentConstants';

export const isValidDriveLink = (text) => {
  if (typeof text !== 'string') return false;

  const trimmed = text.trim();
  if (trimmed === '') return true; // Allow empty as valid
  const driveRegex = /^https:\/\/drive\.google\.com\/file\/d\/[a-zA-Z0-9_-]+\/view(\?.*)?$/;
  const generalUrlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;

  return driveRegex.test(trimmed) || generalUrlRegex.test(trimmed);
};
export const formatUrlWithHttps = (url) => {
  if (typeof url !== 'string' || !url.trim()) return '';

  const trimmedUrl = url.trim();

  // If the URL already has http:// or https://, return it as is
  if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
    return trimmedUrl;
  }

  // Remove leading w., ww., or www. if they exist
  const cleanedUrl = trimmedUrl.replace(/^w{1,3}\./, '');

  // Add https://www. at the beginning
  return `https://www.${cleanedUrl}`;
};
export const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};
export const getFirstDayOfCurrentYear = (format = 'YYYY-MM-DD') => {
  const userTimezone = moment.tz.guess();
  return moment.tz(new Date(), userTimezone).startOf('year').format(format);
};
export const convertToUSDateFormat = (date) => {
  const userTimezone = moment.tz.guess();
  return moment.tz(date, userTimezone).format('MM-DD-YYYY');
};
export const getCurrentDate = (date, format = 'YYYY-MM-DD') => {
  const userTimezone = moment.tz.guess(); // Detect user's local timezone
  return moment.tz(date, userTimezone).format(format);
};
// Converts a given date into a formatted string based on the user's local timezone.
export const convertDateToString = (date, format = 'YYYY-MM-DD') => {
  const userTimezone = moment.tz.guess(); // Detect user's local timezone
  return moment.tz(date, userTimezone).format(format);
};

// Converts a given date into a more readable format based on the user's local timezone.
export const convertToUserTime = (date, format = 'dddd, MMMM Do') => {
  const userTimezone = moment.tz.guess(); // Detect user's local timezone
  return moment.tz(date, userTimezone).format(format);
};

// Converts a date string in 'YYYY-MM-DD' format to a JavaScript Date object.
export const convertStringToDate = (dateString) => {
  return moment(dateString, 'YYYY-MM-DD').toDate();
};

// Gets the start and end dates of the current week based on the user's local timezone.
export const getCurrentWeek = () => {
  const userTimezone = moment.tz.guess(); // Detect user's local timezone
  const dateFrom = moment.tz(userTimezone).startOf('isoWeek').toDate();
  const dateTo = moment.tz(userTimezone).endOf('isoWeek').toDate();
  return {
    dateFrom,
    dateTo,
  };
};
export const getEnvironment = () => {
  return (window.location.origin || '').toLowerCase();
};

// Uncomment when Number Formatting is required
export const formatToCurrency = (value, styles, type = '', prefix = false) => {
  if (getEnvironment().includes('employeeportal.vectorgl.com')) {
    if (value === 0) {
      return '$0'; // Explicitly handle the case where value is 0
    }
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      (typeof value === 'object' && !Array.isArray(value))
    ) {
      return 'N/A'; // Handles null, undefined, empty string, and objects
    }

    // Convert input to a number safely
    const cleanedValue = typeof value === 'string' ? value.replace(/[$,]/g, '') : value;
    const numberValue = Number(cleanedValue);

    if (isNaN(numberValue)) {
      return 'N/A';
    }

    // Format with commas and no decimal places
    const formattedValue = `$${numberValue.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;

    return (
      <Typography
        component="span"
        className={styles ? (numberValue < 0 ? styles.TableTextRed : styles.TableText) : ''}
      >
        {prefix && type ? `${type} ` : ''}
        {formattedValue}
      </Typography>
    );
  } else {
    if (value === 0) {
      return '$0'; // Explicitly handle the case where value is 0
    }
    if (!value || (typeof value === 'object' && !Array.isArray(value))) {
      return 'N/A'; // Handles null, undefined, empty string, and objects
    }

    // Convert input to a number safely
    const cleanedValue = typeof value === 'string' ? value.replace(/[$,]/g, '') : value;
    const numberValue = Number(cleanedValue);

    if (isNaN(numberValue)) {
      return 'N/A';
    }

    // Round to the nearest integer first
    const roundedValue = Math.round(numberValue);

    // Format number with rounding (No decimals, 'K' notation for 1000+)
    const formatNumber = (num) => {
      if (Math.abs(num) >= 10000) {
        const valueInK = num / 1000;
        // Round the value and display without decimals if it ends with .00
        const formattedNum = valueInK % 1 === 0 ? Math.round(valueInK) : valueInK.toFixed(2);
        return `${Number(formattedNum).toLocaleString()}K`; // Add 'K' with comma separators
      }

      // For smaller values, round the number
      const roundedNum = Math.round(num);
      return roundedNum.toLocaleString(); // Display the rounded number
    };

    // Correct negative formatting: -$95K instead of (-$95K)
    const formattedValue =
      numberValue < 0
        ? `-$${formatNumber(Math.abs(roundedValue))}`
        : `$${formatNumber(roundedValue)}`;

    /* return prefix && type ? `${type} ${formattedValue}` : formattedValue; */
    return (
      <Typography
        component="span"
        className={styles ? (numberValue < 0 ? styles.TableTextRed : styles.TableText) : ''}
      >
        {prefix && type ? `${type} ` : ''}
        {formattedValue}
      </Typography>
    );
  }
};

export const formatToNumber = (data, styles, type = null, belowZeroStyling = true) => {
  if (getEnvironment().includes('employeeportal.vectorgl.com')) {
    if (data === 0) {
      return '0'; // Explicitly handle the case where value is 0
    }
    if (data === null || data === undefined || data === '') {
      return 'N/A';
    }

    // Convert input safely
    const cleanedData = typeof data === 'string' ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);

    if (isNaN(numberData)) {
      return 'N/A';
    }

    // Determine decimal precision based on type
    const options =
      type != ''
        ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } // No decimals for "Days"
        : { minimumFractionDigits: 0, maximumFractionDigits: 0 }; // Default formatting

    // Format number in US style
    let formattedValue = numberData.toLocaleString('en-US', options);

    // Append type if provided
    if (type) {
      formattedValue += ` ${type}`;
    }

    // Handle negative values with red styling
    return numberData < 0 && styles ? (
      <Typography component="span" className={styles?.TableTextRed}>
        {formattedValue}
      </Typography>
    ) : (
      formattedValue
    );
  } else {
    if (data === 0) {
      return '0'; // Explicitly handle the case where value is 0
    }
    if (data === null || data === undefined || data === '') {
      return 'N/A';
    }

    // Convert data to string if it's not already a number
    const cleanedData = typeof data === 'string' ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);

    if (isNaN(numberData)) {
      return 'N/A';
    }

    // Convert numbers above 1000 to "K" format
    let formattedValue;
    if (Math.abs(numberData) >= 10000) {
      const valueInK = numberData / 1000;
      formattedValue =
        valueInK % 1 === 0
          ? `${Number(valueInK).toLocaleString('en-US')}K`
          : `${Number(valueInK.toFixed(2)).toLocaleString('en-US')}K`;
    } else {
      // Use toLocaleString to maintain comma formatting for numbers below 10K
      formattedValue = Math.round(numberData).toLocaleString('en-US');
    }

    // Append type if provided
    if (type) {
      formattedValue += ` ${type}`;
    }

    // Handle negative values with red styling
    return numberData < 0 && belowZeroStyling ? (
      <Typography component="span" className={styles.TableTextRed}>
        {formattedValue}
      </Typography>
    ) : (
      formattedValue
    );
  }
};

export const formatToCustomerCurrencyGraph = (num) => {
  if (getEnvironment().includes('employeeportal.vectorgl.com')) {
    if (num === 0) {
      return '$0';
    }
    if (num === null || num === undefined) {
      return 'N/A';
    }

    const absNum = Math.abs(num);

    // Format number with no decimal places and US commas
    const formattedValue = absNum.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // Properly format negative numbers as `-$XX.XX`
    return num < 0 ? `-${formattedValue}` : `${formattedValue}`;
  } else {
    if (num === 0) {
      return '0';
    }
    if (num === null) {
      return 'N/A';
    }

    // Round to the nearest whole number
    const roundedNum = Math.round(num);
    const absNum = Math.abs(roundedNum);
    let formattedValue;

    if (absNum >= 10000) {
      const valueInK = absNum / 1000;
      // If the number is a whole number, show without decimals
      if (valueInK % 1 === 0) {
        formattedValue = `${Number(Math.round(valueInK)).toLocaleString()}K`; // Whole number, no decimals
      } else {
        formattedValue = `${Number(valueInK.toFixed(2)).toLocaleString()}K`; // Number with decimals
      }
    } else {
      formattedValue = `${absNum.toLocaleString()}`;
    }

    // Add a negative sign for negative numbers
    return roundedNum < 0 ? `-${formattedValue}` : formattedValue;
  }
};

export const customSortHelper = (a, b, field) => {
  const getValue = (obj, fieldPath) => {
    // Traverse the object using dot notation (e.g., "country.countryTitle")
    const value = fieldPath
      .split('.')
      .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : null), obj);

    // Handle empty, null, undefined, and invalid values
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      value === 'NA' ||
      value === 'N/A' ||
      value === '-'
    ) {
      return Number.POSITIVE_INFINITY; // Moves N/A and empty values to the bottom
    }

    if (typeof value === 'string') {
      // If the string is purely numeric, return as number
      if (/^-?\d+(\.\d+)?$/.test(value.trim())) {
        return parseFloat(value.trim());
      }
      // Otherwise, return the trimmed string for alphabetical sorting
      return value.trim();
    }

    return value; // Return numbers directly
  };

  const aValue = getValue(a, field);
  const bValue = getValue(b, field);

  if (aValue === Number.POSITIVE_INFINITY && bValue === Number.POSITIVE_INFINITY) return 0;
  if (aValue === Number.POSITIVE_INFINITY) return 1;
  if (bValue === Number.POSITIVE_INFINITY) return -1;

  // Both are strings
  if (typeof aValue === 'string' && typeof bValue === 'string') {
    return aValue.localeCompare(bValue);
  }

  // If one is string and one is number, always put strings above numbers
  if (typeof aValue === 'string' && typeof bValue === 'number') return -1;
  if (typeof aValue === 'number' && typeof bValue === 'string') return 1;

  // Numeric sorting
  return aValue - bValue;
};

export const customSortHelper1 = (a, b, field) => {
  const extractNumericValue = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      value === 'NA' ||
      value === 'N/A' ||
      value === '-' ||
      value === '0'
    ) {
      return Number.POSITIVE_INFINITY; // Push to bottom
    }

    if (typeof value === 'string') {
      const cleaned = value.trim().toUpperCase();

      // Determine multiplier
      const multiplier = cleaned.includes('K')
        ? 1000
        : cleaned.includes('M')
        ? 1000000
        : cleaned.includes('B')
        ? 1000000000
        : 1;

      // Extract numeric portion (e.g., "$1,755.07K" → "1755.07")
      const numericString = cleaned.replace(/[^0-9.-]+/g, '');
      const parsed = parseFloat(numericString);

      return isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed * multiplier;
    }

    return typeof value === 'number' ? value : Number.POSITIVE_INFINITY;
  };

  const getValue = (obj, fieldPath) => {
    // Traverse nested fields if needed (e.g., "user.salary.amount")
    const value = fieldPath
      .split('.')
      .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : null), obj);

    return extractNumericValue(value);
  };

  const aValue = getValue(a, field);
  const bValue = getValue(b, field);

  // Final comparison logic
  if (aValue === Number.POSITIVE_INFINITY && bValue === Number.POSITIVE_INFINITY) return 0;
  if (aValue === Number.POSITIVE_INFINITY) return 1;
  if (bValue === Number.POSITIVE_INFINITY) return -1;

  return aValue - bValue;
};
export const customSortHelper2 = (a, b, fieldPath) => {
  const getValue = (obj, path) => path.split('.').reduce((acc, key) => acc && acc[key], obj) ?? '';

  const valA = getValue(a, fieldPath).toString().toLowerCase();
  const valB = getValue(b, fieldPath).toString().toLowerCase();

  return valA.localeCompare(valB);
};

export const getLoggedInUserData = () => {
  const key = process.env.REACT_APP_SECRET_KEY;
  //const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');

  if (!userCookie) {
    return null;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(userCookie, key);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error('Failed to decrypt or parse user cookie:', error);
    return null;
  }
};

export const checkSupervisorOfSupervisor = (loggedInUserId, targetUserId, employees) => {
  if (loggedInUserId === targetUserId) return false;

  const getEmployeeById = (id) => employees.find((e) => e.id === id);
  let currentUser = getEmployeeById(targetUserId);

  const visited = new Set(); //Prevent circular loops

  while (currentUser && currentUser.myLeader) {
    if (visited.has(currentUser.id)) break;

    if (currentUser.myLeader === loggedInUserId) {
      return true;
    }

    visited.add(currentUser.id);
    currentUser = getEmployeeById(currentUser.myLeader);
  }

  return false;
};

export const setDepartmentName = (departmentName, roleId) => {
  const departmentRoles = {
    [DEPARTMENT_BDM]: {
      1: 'Business Development Manager',
      0: 'Business Development Junior',
    },
    [DEPARTMENT_AA]: {
      1: 'Account Associates Manager',
      0: 'Account Associate',
    },
  };

  return departmentRoles[departmentName]?.[roleId] || departmentName;
};

export const setAssignedForName = (formShortName, userName) => {
  if (formShortName == 'VectorGeneralHealth') {
    return 'N/A';
  } else {
    return userName ? userName : 'N/A';
  }
};

export const getNonAlumniUsers = (usersListCopy, loggedInUserId) => {
  return usersListCopy.filter((user) => user?.roleId === 1 || user?.id === loggedInUserId);
};
export const getPermmission = (type, permissionsList, roleId) => {
  const importDataToolPermissionCopy = permissionsList || [];
  const permission = importDataToolPermissionCopy.find(
    (permission) => permission?.level === roleId && permission?.section === type,
  );

  if (!permission) return false;
  return permission?.accessType == 'NO_ACCESS' ? false : true;
};

export const Instructions = () => {
  return (
    <>
      <Box>
        <Typography variant="h5">Instructions:</Typography>
      </Box>
      <Box mt={1} mb={2}>
        <ul style={{ margin: '0', paddingLeft: '16px' }}>
          <li>
            <Typography variant="body1">
              New employees, cells, and clients must be in the Performance Portal before the data is
              imported.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">Empty cells do not change previous data.</Typography>
          </li>
          <li>
            <Typography variant="body1">
              Cells containing “N/A” or “n/a” will remove the existing value from the Performance
              Portal.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              All formatted cells must contain data for the import function to work.
            </Typography>
          </li>
        </ul>

        <Typography variant="body1">
          {' '}
          Note: All formatted cells must contain data for the import function to work. Please use
          "Save As" to convert the file to .CSV format, and then upload your file.
        </Typography>
      </Box>
    </>
  );
};

export const addLoader = (minimumHeight) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={minimumHeight}>
      <CircularProgress />
    </Box>
  );
};

export const toProperCase = (str) => {
  if (!str) return str;
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getColor = (country) => {
  switch (country) {
    case 'UNITED STATES':
      return '#f15b40';
    case 'MEXICO':
      return '#6eaaa0';
    case 'CHILE':
      return '#0f6e8c';
    case 'PERU':
      return '#fbb03b';
    default:
      return undefined;
  }
};

export const formatToCustomerCurrencyGraphChart = (num) => {
  if (getEnvironment().includes('employeeportal.vectorgl.com')) {
    if (num === 0) {
      return '0';
    }
    if (num === null || num === undefined) {
      return 'N/A';
    }

    const absNum = Math.abs(num);

    if (absNum >= 10000) {
      const valueInK = absNum / 1000;
      // Round the value and display without decimals if it ends with .00
      const formattedNum = valueInK % 1 === 0 ? Math.round(valueInK) : valueInK.toFixed(2);
      return num < 0
        ? `-${Number(formattedNum).toLocaleString('en-US')}K`
        : `${Number(formattedNum).toLocaleString('en-US')}K`;
    }

    // Format number with no decimal places and US commas
    const formattedValue = absNum.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // Properly format negative numbers
    return num < 0 ? `-${formattedValue}` : `${formattedValue}`;
  } else {
    if (num === 0) {
      return '0';
    }
    if (num === null || num === undefined) {
      return 'N/A';
    }

    const absNum = Math.abs(num);

    if (absNum >= 10000) {
      const valueInK = absNum / 1000;
      // Round the value and display without decimals if it ends with .00
      const formattedNum = valueInK % 1 === 0 ? Math.round(valueInK) : valueInK.toFixed(2);
      return num < 0
        ? `-${Number(formattedNum).toLocaleString('en-US')}K`
        : `${Number(formattedNum).toLocaleString('en-US')}K`;
    }

    // Format number with no decimal places and US commas
    const formattedValue = absNum.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // Properly format negative numbers as `-$XX.XX`
    return num < 0 ? `-$${formattedValue}` : `$${formattedValue}`;
  }
};
